import {breakpoint as MQ} from '../utils/mediaQueries.obj';
import {setThemeMode} from '../utils/setThemeMode';
import {scrollLock} from '../utils/scrollLock';
import {Disclosure, DisclosureClose} from "../utils/Disclosure";
import getCSSTransitionDuration from "../utils/getCSSTransitionDuration";
import {trapFocus} from "../utils/trapFocus";

const mainHeader = document.querySelector('.js-main-header');
const logoWrapper = document.querySelector('.js-swap-logo-sticky');
const stickyOffset = 300;
const breakpoint = MQ.breakpoint_medium;

document.addEventListener('DOMContentLoaded', () => {
    const backButtonsMobile = document.querySelectorAll('.js-back-mobile');
    const mainNav = document.getElementById('menu');

    // Boutons de fermeture des sous-menus en mobile
    backButtonsMobile.forEach((backButtonMobile) => {
        const backButtonMobileEvent = new DisclosureClose(backButtonMobile);
        backButtonMobileEvent.init();
    });

    let burgerToggleButtonEvent;

    const burgerIconToggle = (burger, burgerIcon) => {
        if (burger.getAttribute('aria-expanded') === 'true') {
            burgerIcon.classList.add('o-icon--close');
            burgerIcon.classList.remove('o-icon--burger');
        } else {
            burgerIcon.classList.add('o-icon--burger');
            burgerIcon.classList.remove('o-icon--close');
        }
    }

    // Gestion du click du bouton burger
    const burgerEvent = (burger, burgerIcon) => {
        // Gestion du bouton burger
        burger.addEventListener('click', () => {
            // Au clique du bouton burger, on change son icône et on bloque le scroll
            burgerIconToggle(burger, burgerIcon);

            // On ferme les sous-menus par défaut
            backButtonsMobile?.forEach((backButtonMobile) => {
                backButtonMobile.click();
            });
        });
    }

    // Initialisation du bouton burger
    const burgerToggle = () => {
        if (typeof (burgerToggleButtonEvent) !== 'undefined') {
            burgerToggleButtonEvent.destroy();
        }

        // Après l'utilisation de la fonction destroy, on cherche le burger
        const burgerToggleButton = document.querySelector('.js-burger-toggle');
        const burgerIcon = document.querySelector('.js-burger-icon');

        burgerToggleButtonEvent = new Disclosure(
            burgerToggleButton,
            {
                delay: getCSSTransitionDuration(mainNav),
                slide: false,
                closeOnBlur: true
            },
        );

        burgerToggleButtonEvent.init();

        // disclosure.show et disclosure.hide permet d'être sûr que
        burgerToggleButton.addEventListener('disclosure.show', () => {
            burgerIconToggle(burgerToggleButton, burgerIcon);
        });

        burgerToggleButton.addEventListener('disclosure.shown', () => {
            if (window.innerWidth < breakpoint) {
                scrollLock(true);
            }
        });

        burgerToggleButton.addEventListener('disclosure.hide', () => {
            burgerIconToggle(burgerToggleButton, burgerIcon);
            if (window.innerWidth < breakpoint) {
                scrollLock(false);
                burgerToggleButton.focus();
            }
        });

        burgerEvent(burgerToggleButton, burgerIcon);
    }

    const sanitizeStyleAttributes = () => {
        if (document.getElementById('menu')) {
            // Par défault, la navigation principale est toujours visible en desktop
            document.getElementById('menu').removeAttribute('style');
        }
    }

    // Gestion du responsive
    const mediaQuery = window.matchMedia(`(min-width: ${breakpoint}px)`);

    const handleTabletChange = (e) => {
        if (e.matches) {
            // Desktop
            scrollLock(false);
            sanitizeStyleAttributes();
            setThemeMode('.js-navigation', 'dark');
        } else {
            // Mobile
            sanitizeStyleAttributes();
            burgerToggle();
            // Initialisation des sous-menus mobile
            setThemeMode('.js-navigation', 'light');
            // Trap focus sur la navigation principale et les sous-menus en mobile
            trapFocus(document.querySelector('.js-navigation'));
            document.querySelectorAll('.c-mega-menu').forEach(megaMenu => {
                trapFocus(megaMenu);
            });
        }
    }

    mediaQuery.addEventListener('change', handleTabletChange);

    handleTabletChange(mediaQuery);
});
